// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"5715e555","663":"eed77078"}[chunkId] + ".chunk.js";
};